import { isRegexMatch } from "@sscs/utils";
export const initFilter = {
    onEvent: "ALL",
    eventName: null,
    doAction: "ALL",
};
export const initSort = {
    property: "on_event",
    reverse: false,
};
export const filterActions = (actions, filter) => {
    const hasOnEventFilter = filter.onEvent !== initFilter.onEvent;
    const hasEventNameFilter = filter.eventName !== initFilter.eventName;
    const hasDoActionFilter = filter.doAction !== initFilter.doAction;
    if (!hasOnEventFilter && !hasEventNameFilter && !hasDoActionFilter) {
        return actions;
    }
    return actions.filter((action) => {
        if (hasOnEventFilter && action.on_event !== filter.onEvent) {
            return false;
        }
        if (hasEventNameFilter &&
            filter.eventName &&
            !isRegexMatch(action.event_name, filter.eventName)) {
            return false;
        }
        if (hasDoActionFilter && action.do_action !== filter.doAction) {
            return false;
        }
        return true;
    });
};
export const getPrimaryPropertiesLabel = (actionMappings, action) => {
    if (actionMappings[action.do_action] === undefined) {
        return "";
    }
    const { properties, delimiter } = actionMappings[action.do_action];
    const orderedValues = Object.keys(properties)
        .map((key) => action.properties.find(([actionProperty]) => actionProperty === key))
        .filter((actionProperty) => actionProperty !== undefined &&
        properties[actionProperty[0]].type === "primary")
        .map((property) => property[1]);
    return orderedValues.join(delimiter === ":" ? " \u2192 " : delimiter);
};
//# sourceMappingURL=utils.js.map